export const CART_CTA = 'GO TO CART';
export const ADD_CTA = 'ADD';
export const NOTIFY_ME_CTA = 'Notify Me';
export const MULTIPLE_SKU_HEADER = 'Select Packform';
export const ADD_ITEM_SUCESS_MSG = 'Item successfully Added to Cart';
export const REMOVE_ITEM_SUCESS_MSG = 'Item successfully Removed from Cart';
export const ADD_ITEM_FAIL_MSG = 'Item Add to Cart Failed';
export const REMOVE_ITEM_FAIL_MSG = 'Item Remove from Cart Failed';